import Vue from 'vue';
import Vuex from 'vuex';
import pathify, { make } from 'vuex-pathify';
import isEmpty from 'lodash/isEmpty';

import ls from '@/util/ls';

// Import modules
import articlesBulkDialog from './modules/articlesBulkDialog';
import articlesDeleteDialog from './modules/articlesDeleteDialog';
import articlesRefetchStatsDialog from './modules/articlesRefetchStatsDialog';
import events from './modules/events';
import projects from './modules/projects';
import reports from './modules/reports';
import articlesNew from './modules/articles';
import users from './modules/users';
import outputs from './modules/outputs';

const state = {

	// Global data
	notification: { type: 'primary', text: '', to: '' },
	productionDB: true,
	skills: ls.get('skills', { uid: null, items: [] }),

	/**
	 * Project data, loading depends on current project
	 * @todo Move usage to current project
	 */
	categories: [],
	categoriesArchived: [],
	keywordLists: [],
	overrides: [],
	markdownOptions: [],
	outputSortSettings: [],

	// Reports
	reportPublications: [],

	// Articles
	articles: [],
	deletedArticles: [],
	authorNames: [],

	// Super user
	superUser: false,
	accounts: null,
};

const getters = {

	/**
	 * @param {number} id Skill name
	 * @returns {boolean} If this user has provided skill
	 */
	isSkilled: (state) => (id) => {
		const uid = ls.get('id', null);
		if (!state.skills || uid !== state.skills.uid) {
			return false;
		}

		return (state.skills.items.indexOf(id) > -1);
	},

};

const mutations = {

	...make.mutations(state),

	REMOVE_ARTICLE_BY_ID(state, articleId) {
		const deleteIndex = state.articles.findIndex(article => article.id === articleId);
		if (deleteIndex > -1) {
			state.articles.splice(deleteIndex, 1);
		}
	},

	REMOVE_DELETED_ARTICLE_BY_ID(state, articleId) {
		const deleteIndex = state.deletedArticles.findIndex(article => article.id === articleId);
		if (deleteIndex > -1) {
			state.deletedArticles.splice(deleteIndex, 1);
		}
	},

};

const actions = {

	...make.actions('notification'),

	loadAuthorNames({ commit, state }) {
		if (!isEmpty(state.authorNames)) {
			return;
		}

		// Import dynamically because when just logged in and import axios, authKey is not set yet
		import('@/util/axios').then((axios) => {
			axios.default.get('/articles/authors').then((resp) => {
				commit('SET_AUTHOR_NAMES', resp.data);
			}).catch((e) => {
				dump('Error getting all author names', e);
			});
		});
	},
};

Vue.use(Vuex);

export default new Vuex.Store({
	plugins: [pathify.plugin],
	modules: {
		articlesBulkDialog,
		articlesDeleteDialog,
		articlesRefetchStatsDialog,
		events,

		projects,
		reports,
		articlesNew,
		users,
		outputs,
	},
	state,
	getters,
	mutations,
	actions,
});
